import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { apiData } from 'src/app/services/api-lookup';
import { ApiService } from 'src/app/services/api.service';
import { Router } from '@angular/router';
const GenerateOtp = apiData[324].GenerateOtp;
const ForgotPassword = apiData[9].ForgotPassword;
const VerifyPassword = apiData[347].VerifyPassword;
const VerifyForgotPasswordOtp = apiData[198].VerifyForgotPasswordOtp;

type StepNumber = 1 | 2 | 3 | 4;

@Component({
  selector: 'app-change-password-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule, MatIconModule],
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.scss']
})
export class ChangePasswordModalComponent {

  currentStep: StepNumber = 1;
  passwordLength = 12;
  passwordLengthError = '';
  currentPassword = '';
  currentPasswordVisible = false;
  currentPasswordError = '';


  newPassword = '';
  confirmPassword = '';
  newPasswordVisible = false;
  confirmPasswordError = '';

  rules = {
    len: false,
    upper: false,
    lower: false,
    num: false,
    special: false
  };

  otpDigits: string[] = ['', '', '', '', '', ''];
  otpError = '';
  maskedEmail = ''; 
  resendSecondsLeft = 60;
  private resendTimer: any;
  constructor(
  public dialogRef: MatDialogRef<ChangePasswordModalComponent>,
  private apiService: ApiService,
  private router: Router
) {}

  ngOnDestroy(): void {
    if (this.resendTimer) {
      clearInterval(this.resendTimer);
    }
  }

ngOnInit(): void {

  const policy = sessionStorage.getItem('PasswordPolicy');
  let settings: any = null;

  try {
    settings = policy ? JSON.parse(policy) : null;
  } catch {
    settings = null;
  }

  if (settings) {

    const minLen = Number(
      settings.minPasswordLength ??
      settings.MinPasswordLength ??
      settings.minLength
    );

    this.passwordLength = minLen > 0 ? minLen : 12;

    this.passwordPolicy = {
      requireUppercase: settings.requireUppercase ?? true,
      requireLowercase: settings.requireLowercase ?? true,
      requireNumber: settings.requireNumber ?? true,
      requireSpecialCharacter: settings.requireSpecialCharacter ?? true
    };

  } else {

    this.passwordLength = 12;

    this.passwordPolicy = {
      requireUppercase: true,
      requireLowercase: true,
      requireNumber: true,
      requireSpecialCharacter: true
    };
  }
}
passwordPolicy = {
  requireUppercase: true,
  requireLowercase: true,
  requireNumber: true,
  requireSpecialCharacter: true
};
  
  toggleVisibility(field: 'current' | 'new'): void {
    if (field === 'current') this.currentPasswordVisible = !this.currentPasswordVisible;
    if (field === 'new') this.newPasswordVisible = !this.newPasswordVisible;
  }
onContinue(): void {
  if (!this.currentPassword?.trim()) {
    this.currentPasswordError = 'Current password is incorrect';
    return;
  }

  const storedUser = sessionStorage.getItem('User');
  const user = storedUser
    ? JSON.parse(atob(JSON.parse(storedUser)))
    : null;

  const email = user?.email ?? '';


  

  const apiUrl = `${VerifyPassword}`;

  const body = {
    Email: email,
    Password: this.currentPassword
  };

  this.apiService.httpPost(apiUrl, body).subscribe({
    next: (res: any) => {
      if (!res.isValid) {
        this.currentPasswordError =
          "That password doesn't match our records. Try again.";
        return;
      }

      this.currentPasswordError = '';
      this.goToStep(2);
    },
    error: () => {
      this.currentPasswordError =
        "That password doesn't match our records. Try again.";
    }
  });

}


checkRules(): void {

  const val = this.newPassword;

  this.rules = {
    len: val.length >= this.passwordLength,
    upper: !this.passwordPolicy.requireUppercase || /[A-Z]/.test(val),
    lower: !this.passwordPolicy.requireLowercase || /[a-z]/.test(val),
    num: !this.passwordPolicy.requireNumber || /\d/.test(val),
    special: !this.passwordPolicy.requireSpecialCharacter || /[^A-Za-z0-9]/.test(val)
  };

  if (val.length > 0 && val.length < this.passwordLength) {
    this.passwordLengthError =
      `Password must be at least ${this.passwordLength} characters.`;
  } else {
    this.passwordLengthError = '';
  }

  if (val.length > 0 && val === this.currentPassword) {
    this.newPasswordError =
      'New password must be different from your current password';
  } else {
    this.newPasswordError = '';
  }

  this.validateConfirm();
}
  validateConfirm(): void {
    if (this.confirmPassword.length > 0 && this.confirmPassword !== this.newPassword) {
      this.confirmPasswordError = "Passwords don't match.";
    } else {
      this.confirmPasswordError = '';
    }
  }

  get allRulesMet(): boolean {
    return Object.values(this.rules).every(Boolean);
  }

  get canSendOtp(): boolean {
  return this.allRulesMet &&
    !this.newPasswordError &&
    this.confirmPassword.length > 0 &&
    this.confirmPassword === this.newPassword;
}
generateOtp(userId: number, imId: number, email: string) {

  const apiUrl = `${GenerateOtp}`;

  const body = {
    UserId: userId,
    ImId: imId,
    ExpiryMinutes: 10,
    EventType: 'CHANGE_PASSWORD_OTP',
    Ip: '',
    Email: email
  };

  return this.apiService.httpPost(apiUrl, body);
}



newPasswordError = '';
otpChallengeId: string | null = null;

onSendOtp(): void {

  if (!this.canSendOtp) {
    console.log('Password rules are not satisfied');
    return;
  }

  const storedUser = sessionStorage.getItem('User');

  const user = storedUser
    ? JSON.parse(atob(JSON.parse(storedUser)))
    : null;

  const storedAdviser = sessionStorage.getItem('Adviser');

  const adviser = storedAdviser
    ? JSON.parse(atob(JSON.parse(storedAdviser)))
    : null;

  const userId = Number(user?.id ?? 0);
  const imId = Number(adviser?.iM_Id ?? 0);
  const email = user?.email ?? '';

  console.log('========== CHANGE PASSWORD OTP ==========');
  console.log('User:', user);
  console.log('Adviser:', adviser);
  console.log('UserId:', userId);
  console.log('ImId:', imId);
  console.log('Email:', email);
  console.log('GenerateOtp API:', GenerateOtp);

  if (!userId) {
    console.error('UserId is missing');
    return;
  }

  if (!email) {
    console.error('Email is missing');
    return;
  }

  this.maskedEmail = this.maskEmail(email);

  this.generateOtp(userId, imId, email).subscribe({

    next: (response: any) => {

      console.log('Generate OTP SUCCESS:', response);

      this.otpChallengeId = response?.challengeId ?? null;

      this.goToStep(3);
      this.startResendTimer();

    },

    error: (err) => {

      console.error('Generate OTP ERROR:', err);
      console.error('Status:', err?.status);
      console.error('Response:', err?.error);

      this.otpError =
        err?.error?.message ||
        err?.error?.Message ||
        'Unable to send OTP. Please try again.';

    }

  });
}
private maskEmail(email: string): string {

  if (!email || !email.includes('@')) {
    return '';
  }

  const [name, domain] = email.split('@');

  return name.substring(0, 2) + '****@' + domain;
}

onOtpInput(event: Event, index: number, next: HTMLInputElement | null): void {

  const input = event.target as HTMLInputElement;

  input.value = input.value.replace(/\D/g, '').slice(-1);

  this.otpDigits[index] = input.value;

  if (input.value && next) {
    next.focus();
  }

  this.otpError = '';
}
  onOtpKeydown(index: number, event: KeyboardEvent): void {

  if (event.key === 'Backspace') {

    if (this.otpDigits[index]) {

      this.otpDigits[index] = '';

    } else if (index > 0) {

      const prev = document.getElementById('otp-' + (index - 1)) as HTMLInputElement;

      prev?.focus();
    }
  }
}
moveToPrev(event: KeyboardEvent, previous: HTMLInputElement | null): void {

  const input = event.target as HTMLInputElement;

  if (event.key === 'Backspace' && input.value === '' && previous) {
    previous.focus();
  }
}
  startResendTimer(): void {
    clearInterval(this.resendTimer);
    this.resendSecondsLeft = 60;
    this.resendTimer = setInterval(() => {
      this.resendSecondsLeft--;
      if (this.resendSecondsLeft <= 0) {
        clearInterval(this.resendTimer);
      }
    }, 1000);
  }

get resendTimerLabel(): string {
  const minutes = Math.floor(this.resendSecondsLeft / 60);
  const seconds = this.resendSecondsLeft % 60;

  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

  onResendOtp(): void {
    if (this.resendSecondsLeft > 0) return;
 
    this.startResendTimer();
  }

  changePassword(email: string, newPassword: string) {
  const apiUrl = `${ForgotPassword}`;

  const body = {
    Email: email,
    Newpassword: newPassword
  };

  return this.apiService.httpPost(apiUrl, body);
}

verifyChangePasswordOtp(userId: number, otp: string) {

  const apiUrl = `${VerifyForgotPasswordOtp}`;

  const body = {
    Id: userId,
    Otp: otp,
    ChallengeId: this.otpChallengeId
  };

  return this.apiService.httpPost(apiUrl, body);
}
  onVerifyOtp(): void {

  const code = this.otpDigits.join('');

  if (code.length < 6) {
    this.otpError = 'Enter all 6 digits.';
    return;
  }

  const storedUser = sessionStorage.getItem('User');

  const user = storedUser
    ? JSON.parse(atob(JSON.parse(storedUser)))
    : null;

  const userId = Number(user?.id ?? 0);
  const email = user?.email ?? '';

  if (!userId || !email) {
    this.otpError = 'User information not found.';
    return;
  }

  this.otpError = '';

  this.verifyChangePasswordOtp(userId, code).subscribe({

    next: (otpResponse: any) => {

      if (!otpResponse?.success) {
        this.otpError = 'Invalid or expired OTP.';
        return;
      }

      this.changePassword(email, this.newPassword).subscribe({

        next: (passwordResponse: any) => {

          if (passwordResponse?.success) {

            this.goToStep(4);

            setTimeout(() => {
              this.dialogRef.close();
              this.router.navigate(['/authentication/login']);
            }, 2000);

          } else {
            this.otpError = 'Password update failed.';
          }

        },

        error: () => {
          this.otpError = 'Error updating password.';
        }

      });

    },

    error: () => {
      this.otpError = 'Invalid or expired OTP.';
    }

  });
}
  goToStep(step: StepNumber): void {
    this.currentStep = step;
  }

  onBack(): void {
    if (this.currentStep > 1) {
      this.goToStep((this.currentStep - 1) as StepNumber);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onFinish(): void {
    this.dialogRef.close({ success: true });
  }
}